import { Search, Doc, Card, Shield, Check } from '../Icons';

const stages = [
  { Icon: Search, who: 'Sender', title: 'Selects a traveller', text: 'Based on route, date, mode and capacity only.' },
  { Icon: Doc, who: 'Platform', title: 'Request submitted', text: 'The request goes to the admin, not directly to the traveller.' },
  { Icon: Card, who: 'Sender', title: 'Payment made', text: 'Secure checkout. Funds are held by the platform.' },
  { Icon: Shield, who: 'Admin', title: 'Review & verification', text: 'Item, sender and traveller are checked against our policies.' },
  { Icon: Check, who: 'Admin', title: 'Traveller assigned', text: 'Official assignment. Only now are the relevant details shared.' },
];

export default function AssignmentFlow() {
  return (
    <section className="section section--dark" id="flow">
      <div className="container flow">
        <div className="flow__copy reveal">
          <span className="kicker kicker--light">Admin-controlled assignment</span>
          <h2>A human checks every match before it happens</h2>
          <p>
            Unlike open marketplaces, senders and travellers never negotiate directly. Every request passes
            through our admin team, which gives the platform full control over privacy, verification, safety
            and the final assignment.
          </p>
          <ul className="flow__points">
            <li><Check width={18} height={18} /> No direct contact until the assignment is official</li>
            <li><Check width={18} height={18} /> Prohibited items screened out before pickup</li>
            <li><Check width={18} height={18} /> Payment is released only for approved assignments</li>
          </ul>
        </div>

        <ol className="timeline">
          {stages.map(({ Icon, who, title, text }, i) => (
            <li className="timeline__item reveal" key={title} style={{ '--delay': `${i * 80}ms` }}>
              <div className={`timeline__icon ${i === stages.length - 1 ? 'is-final' : ''}`}><Icon width={20} height={20} /></div>
              <div className="timeline__body">
                <span className={`who who--${who.toLowerCase()}`}>{who}</span>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
